import type { Role } from "./schemas/tenant";

// Two-step sign-in (a code from an authenticator app, or a texted code as the
// backup) for the people who can change the company: owners, admins, and
// Clevis staff. It's asked once when signing in on a device — never per
// click — and devices stay signed in as before. Firebase itself refuses a
// sign-in without the second step once someone has set it up; the app makes
// sure owners and admins set it up.

/** Roles that must use two-step sign-in. */
export const TWO_STEP_ROLES: readonly Role[] = ["owner", "admin"];
/** Owners and admins on the day this shipped have until this date. */
export const TWO_STEP_REQUIRED_FROM = Date.UTC(2026, 10, 7, 12); // Nov 7, 2026
/** Someone made owner or admin later gets this long to set it up. */
export const TWO_STEP_GRACE_MS = 7 * 86_400_000;

export function twoStepRequired(role: Role | null | undefined, superAdmin: boolean): boolean {
  return superAdmin || (!!role && TWO_STEP_ROLES.includes(role));
}

/** When two-step stops being optional for this person (roleSince: when they became owner/admin). */
export function twoStepDueAt(roleSince: number | null | undefined): number {
  return Math.max(TWO_STEP_REQUIRED_FROM, (roleSince ?? 0) + TWO_STEP_GRACE_MS);
}
